import { UtensilsCrossed, Factory, LayoutGrid, LifeBuoy, Users, MessageSquareQuote, Handshake, Puzzle, RotateCw, Grip } from "lucide-react";

export const getOfferItems = (t: any, lang: string) => [
  { label: t.offerGastroMedicine, href: "/solutions/gastronomy-medicine", icon: UtensilsCrossed, subItems: [
    { label: t.solGastSinks, href: "/solutions/spot-welding-sinks" },
  ]},
  { label: t.offerProducts, href: "/products", icon: Factory, subItems: [
    { label: t.prodSpotWeldingCategory, href: "/products/spot-welding", isCategory: true, subItems: [
      { label: lang === "en" ? "Rocker Arm Welders" : "Stroji s škarjastim hodom", href: "/products/spot-welding", isCategory: true, subItems: [
        { label: "RS-81 / RP-81 MFDC", href: "/products/spot-welding/rs-81" },
        { label: "RB-81", href: "/products/spot-welding/rb-81" },
      ]},
      { label: lang === "en" ? "Linear Action Welders RT-94" : "Stroji z linearnim hodom RT-94", href: "/products/spot-welding/rt-94" },
      { label: lang === "en" ? "Bench Welders RP-84" : "Namizni stroji RP-84", href: "/products/spot-welding/rp-84" },
      { label: lang === "en" ? "Industrial Welding Guns" : "Industrijske klešče za varjenje", href: "/products/spot-welding", isCategory: true, subItems: [
        { label: "RP-96-X", href: "/products/spot-welding/rp-96-x" },
        { label: "RP-96-C", href: "/products/spot-welding/rp-96-c" },
      ]},
      
      { label: lang === "en" ? "Twin Spot Welders" : "Dvojni točkovni varilniki", href: "/products/spot-welding", isCategory: true, subItems: [
        { label: "RGS", href: "/products/spot-welding/rgs" },
        { label: "RDR", href: "/products/spot-welding/rdr" },
      ]},
      { label: lang === "en" ? "Hand Held Welding Gun" : "Ročni varilni točkalnik", href: "/products/spot-welding/hand-held-welding-gun" },
    ]},
    { label: lang === "en" ? "Projection Welding RT-94" : "Bradavičasto varjenje RT-94", href: "/products/projection-welding", isCategory: true, subItems: [] },
    { label: lang === "en" ? "Seam Welders" : "Kolutno varjenje", isCategory: true, subItems: [
      { label: "RK-94", href: "/products/seam-welding/rk-94" },
    ] },
    { label: lang === "en" ? "Butt Welder RP-97" : "Stroj za sočelno varjenje RP-97", href: "/products/butt-welding", isCategory: true, subItems: [] },
    { label: t.prodMicroWelding, href: "/products/micro-welding", isCategory: true, subItems: [
      { label: lang === "en" ? "Servo Welding Heads" : "Servo varilne glave", href: "/products/servo-welding-heads" },
      { label: lang === "en" ? "Double Welding Heads" : "Dvojne varilne glave", href: "/products/double-welding-heads" },
      { label: t.prodWeldingHeads, href: "/products/welding-heads" },
      { label: t.prodWeldingPincers, href: "/products/welding-pincers" },
      { label: t.prodCompactingTools, href: "/solutions/compacting-tools" },
      { label: t.prodBatteryProcessing, href: "/products/battery-processing" },
      { label: t.prodWorkstations, href: "/products/workstation" },
    ]},
    { label: lang === "en" ? "Car Spotters" : "Varilni program za avtoličarstvo", href: "/products/car-spotters", isCategory: true, subItems: [
      { label: "Car Point", href: "/products/spot-welding/car-point" },
      { label: "Europei", href: "/products/spot-welding/europei" },
      { label: "MFDC Welding Unit", href: "/products/spot-welding/mfdc-welding-unit" },
      { label: "RP-84/3,5-ECO", href: "/products/spot-welding/fast-spotter" },
    ]},
  ]},
  { label: t.offerSpecialMachines, href: "/solutions", icon: LayoutGrid, subItems: [
    { label: t.prodPedestalWelders, href: "/products/industrial-pedestal-welders" },
    { label: t.prodProjectionWelders, href: "/products/industrial-projection-welders" },
    { label: t.prodSeamWelders, href: "/products/industrial-seam-welders" },
    { label: t.prodMultiSpot, href: "/products/multi-spot-welding-machine" },
    { label: t.solRoboticSpotGuns, href: "/solutions/robotic-spot-welding-guns" },
    { label: t.solLocksWelding, href: "/solutions/lock-welding" },
    { label: t.solGastPillow, href: "/solutions/seam-welding-pillow-plates" },
  ] },
  { label: lang === "en" ? "Spare Parts & Components" : "Rezervni deli in komponente", href: "/spare-parts", icon: Puzzle, subItems: [
    { label: lang === "en" ? "Seam Welding Heads" : "Kolutne glave", href: "/spare-parts#seam-wheels", isCategory: true, subItems: [] },
    { label: lang === "en" ? "Transformers" : "Transformatorji", href: "/spare-parts#transformers", isCategory: true, subItems: [
      { label: lang === "en" ? "Single-Phase AC" : "Enofazni AC", href: "/spare-parts#transformers" },
      { label: lang === "en" ? "Three-Phase Rectifier" : "Trifazne usmerniške enote", href: "/spare-parts#transformers" },
      { label: "MFDC Inverter", href: "/spare-parts#transformers" },
      { label: lang === "en" ? "Heating Transformers" : "Grelni transformatorji", href: "/spare-parts#transformers" },
    ]},
    { label: lang === "en" ? "Welding Components" : "Varilne komponente", href: "/spare-parts#controllers", isCategory: true, subItems: [
      { label: "Bosch Rexroth", href: "/spare-parts/bosch-rexroth" },
      { label: "Harms & Wende", href: "/spare-parts/harms-wende" },
      
    ]},
  ]},
  { label: lang === "en" ? "Consumables" : "Potrošni material", href: "/consumables", icon: RotateCw, subItems: [
    { label: lang === "en" ? "Electrodes" : "Elektrode", href: "/consumables#electrodes" },
    { label: lang === "en" ? "Ceramic Pins" : "Keramični pini", href: "/consumables#ceramic-pins" },
  ]},
  { label: lang === "en" ? "Accessories" : "Dodatna oprema", href: "/accessories", icon: Grip, subItems: [
    { label: lang === "en" ? "Tip Dressers" : "Posnemovalci kapic", href: "/accessories/tip-dressers" },
  ]},
  { label: t.offerServices, href: "/services", icon: LifeBuoy, subItems: [] },
];

export const getTrustItems = (t: any) => ({
  reference: [
    { label: t.refUsers, href: "/users-clients", icon: Users },
  ],
  testimonials: [
    { label: t.refTestimonials, href: "/testimonials", icon: MessageSquareQuote },
  ],
  partners: [
    { label: t.refPartners, href: "/partners", icon: Handshake },
  ],
});

export const getNavItems = (t: any) => [
  { label: t.navHome, href: "/" },
  { label: t.navAbout, href: "/about-us", isPage: true },
  { label: t.navServices, href: "/#services", dropdown: "offer" as const },
  { label: t.navReferences, href: "/#references", dropdown: "trust" as const },
  { label: t.navKnowledge, href: "/knowledge-hub" },
  { label: t.navFAQ, href: "/faq" },
  { label: t.navContact, href: "/#contact" },
];
